import state from "./surveyState";
import mutations from "./surveyMutations";
import getters from "./surveyGetters";
import surveyActions from "./surveyActions";
import integrationActions from "./integrationActions";
import compositeActions from "./compositeActions";
import jumpLogicActions from "./jumpLogicActions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {
    ...surveyActions,
    ...integrationActions,
    ...compositeActions,
    ...jumpLogicActions
  }
};
